import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		/* ------------ home ----------- */
		HOME_FULLPAGE: null,		// home 全屏滚动类
		VIDEO_SHOW: false,			// 视频播放器显示状态
		VIDEO_URL: "",				// 视频播放器yotube地址
		NEWS_SHOW: false,
		NEWS_CONTENT: "",			// 新闻详细内容

		VIDEO_ARR: {				// 背景视频
			loading: "",
			TOP: "",
			NEWS: "",
			WORLD: "",
		},
		VIDEO_BG: {					// 背景视频图片
			TOP: "",
			NEWS: "",
			WORLD: "",
		},
		
		PRELOADIMGLIST: [],
		WORLD_YOTUBE_URL: "",		// yotube播放地址
		SYSTEM_YOTUBE_URL: "",
		/* ------------ prereg ----------- */
		PREREG_FULLPAGE: null,		// prereg 全屏滚动类
	},
	mutations: {
		/* ------------ home ----------- */
		INIT_HOME_FULLPAGE: (state, params) => {
			state.HOME_FULLPAGE = params
		},
		SET_VIDEO: (state, params) => {			// 设置视频播放器参数
			state.VIDEO_URL = params.videoUrl;
			state.VIDEO_SHOW = params.videoShow;
		},
		SET_BLOBURL: (state, params) => {
			state.VIDEO_ARR[params.name] = params.bloburl;
		},
		SET_VIDEO_BG: (state, params) => {
			state.VIDEO_BG[params.name] = params.imgurl;
		},
		SET_NEWS: (state, params) => {
			state.NEWS_SHOW = params.status;
			state.NEWS_CONTENT = params.content;
		},
		SET_PRELOADIMGLIST: (state, params) => {
			state.PRELOADIMGLIST = params
		},
		SET_YOUTUBEURL: (state, params) => {
			state.WORLD_YOTUBE_URL = params.world;
			state.SYSTEM_YOTUBE_URL = params.system;
		},
		/* ------------ prereg ----------- */
		INIT_PREREG_FULLPAGE: (state, params) => {
			state.PREREG_FULLPAGE = params
		},
	},
	actions: {

	},
	getters: {
		videoList(state) {		// page01 视频和图标
			return [
				{
					videoUrl: state.VIDEO_ARR.home_page01_1,
					imgUrl: "/images/home/page01/1.png"
				},
				{
					videoUrl: state.VIDEO_ARR.home_page01_2,
					imgUrl: "/images/home/page01/2.png"
				},
				{
					videoUrl: state.VIDEO_ARR.home_page01_4,
					imgUrl: "/images/home/page01/4.png"
				},
				{
					videoUrl: state.VIDEO_ARR.home_page01_5,
					imgUrl: "/images/home/page01/5.png"
				}
			]
		}		
	}
})
